import { PendingApprovals } from '@components/approvals';
import { Navigation } from '@components/navigation';
import React, { Fragment, FunctionComponent } from 'react';

interface IProps {}

const Admin: FunctionComponent<IProps> = () => (
  <Fragment>
    <Navigation />
    <main>
      <h1 className="ftg-heading">Fact Tag Generator</h1>
      <div className="site-wide">
        <PendingApprovals />
      </div>
    </main>
  </Fragment>
);

export default Admin;
